export default __webpack_public_path__ + "static/media/30t.184b2f95.jpg";